import { render } from "./SupplierList.vue?vue&type=template&id=05bc7196&scoped=true"
import script from "./SupplierList.vue?vue&type=script&lang=js"
export * from "./SupplierList.vue?vue&type=script&lang=js"

import "./SupplierList.vue?vue&type=style&index=0&id=05bc7196&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05bc7196"]])

export default __exports__